export enum SiteType {
  ESPNSWFL = 'espnswfl',
  B1027VGS = '1027vgs',
  AUGUSTATODAY = 'augustatoday',
  COYOTECOUNTRYLV = 'coyotecountrylv',
  FOXY99 = 'foxy99',
  WKML = 'wkml',
  PLAYJACKRADIO = 'playjackradio',
  B1077THEBOUNCE = '1077thebounce',
  MYKISSRADIO = 'mykissradio',
  SUNNY943 = 'sunny943',
  WRAT = 'wrat',
  MAGIC983 = 'magic983',
  WDHAFM = 'wdhafm',
  WJRZ = 'wjrz',
  WMTRAM = 'wmtram',
  WTMRRADIO = 'wtmrradio',
  WGAC = 'wgac',
  KICKS99 = 'kicks99',
  HD983 = 'hd983',
  HOTAUGUSTA = 'hotaugusta',
  SUNNY1027 = 'sunny1027',
  ILOVEBOBFM = 'ilovebobfm',
  WRIF = 'wrif',
  BACKSTAGECOUNTRY = 'backstagecountry',
  CHECKPOINTXP = 'checkpointxp',
  DAVEANDCHUCKTHEFREAK = 'daveandchuckthefreak',
  PODCASTRADIOUS = 'podcastradious',
  ROARDETROIT = 'roardetroit',
  THEANDIESUMMERSSHOW = 'theandiesummersshow',
  MUSTHAVESANDFUNFINDS = 'musthavesandfunfinds',
  X1075LASVEGAS = 'x1075lasvegas',
  WROR = 'wror',
  WWDBAM = 'wwdbam',
  WMGK = 'wmgk',
  WMMR = 'wmmr',
  WILD941 = 'wild941',
  WJBR = 'wjbr',
  V1019 = 'v1019',
  WCSX = 'wcsx',
  THEBOUNCESWFL = 'thebounceswfl',
  ROCK929ROCKS = 'rock929rocks',
  SUNNY1063 = 'sunny1063',
  PLAYATAMPA = 'playatampa',
  POWER98FM = 'power98fm',
  MYQ105 = 'myq105',
  PLAYA993 = 'playa993',
  KISS951 = 'kiss951',
  KISSFMDETROIT = 'kissfmdetroit',
  K1047 = 'k1047',
  GETUPCREWSHOW = 'getupcrewshow',
  HOT969BOSTON = 'hot969boston',
  FOXSPORTSRADIOCHARLOTTE = 'foxsportsradiocharlotte',
  FOXSPORTSRADIONEWJERSEY = 'foxsportsradionewjersey',
  DETROITPRAISENETWORK = 'detroitpraisenetwork',
  COUNTRY1025 = 'country1025',
  COUNTRY1037FM = 'country1037fm',
  B995QYK = '995qyk',
  B1039 = 'b1039',
  B96KROCK = '96krock',
  B975THEFANATIC = '975thefanatic',
  B985THESPORTSHUB = '985thesportshub',
  B987THESHARK = '987theshark',
  B925MAXIMA = '925maxima',
  B925XTU = '925xtu',
  B957BENFM = '957benfm',
  B963KKLZ = '963kklz',
  B1057MAXIMA = '1057maxima',
  B1051THEBOUNCE = '1051thebounce',
}

export interface IGetDefaultThemeParams {
  color: {
    primary: string;
    secondary: string;
    brand: {
      main: string;
      text: string;
      highlight?: string;
      listenLive?: string;
    };
    text?: {
      primary?: string;
      secondary?: string;
    };
    error: string;
  };
  font?: {
    base: string;
    sans: string;
    serif: string;
  };
}

export interface ISTNPlayerInfoParams {
  key: string;
  cid: string;
  fk: string;
  type: string;
}
